'use client'

import type { StorageAllocation } from '@garage/shared'
import { InventoryIcon } from '@/ui'
import { api } from '@/lib/api.js'

/**
 * One allocated item, shown small: a photo icon (or a placeholder) and its
 * name/quantity — clicking opens the full detail (bigger photo, notes, when
 * it was added) instead of cramming all of that into the tile itself.
 */
export function AllocationIcon({ allocation, onClick }: { allocation: StorageAllocation; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-surface-high interactive text-center"
    >
      <div className="w-12 h-12 rounded-md overflow-hidden bg-surface-high border border-outline-variant flex items-center justify-center flex-shrink-0">
        {allocation.photos[0] ? (
          <img
            src={api.storage.itemPhotoUrl(allocation.id, allocation.photos[0].id, 128)}
            alt={allocation.itemName}
            className="w-full h-full object-cover"
            width={48}
            height={48}
            loading="lazy"
            decoding="async"
          />
        ) : (
          <InventoryIcon className="w-5 h-5 text-on-surface-variant" />
        )}
      </div>
      <div className="text-body-sm text-on-surface truncate w-full">{allocation.itemName}</div>
      <div className="text-body-sm text-on-surface-variant">× {allocation.quantity}</div>
    </button>
  )
}
